
const GET_ASSESSMENT                = 'GET_ASSESSMENT';
const ADD_ASSESSMENT                = 'ADD_ASSESSMENT';
const SET_FORM_GUID                 = 'SET_FORM_GUID';
const CLEAR_FORM_GUID               = 'CLEAR_FORM_GUID';
const REMOVE_ALL_ASSESSMENTS        = 'REMOVE_ALL_ASSESSMENTS';

const GET_SESSION_HEADER            = 'GET_SESSION_HEADER';
const GET_SURVEY                    = 'GET_SURVEY';
const GET_ITEMS                     = 'GET_ITEMS';
const GET_CSS                       = 'GET_CSS';
const GET_ANSWERED_QUESTION         = 'GET_ANSWERED_QUESTION';
const SCROLL_TO_QUESTION            = 'SCROLL_TO_QUESTION';
const SINGLE_ITEM_RESET_SLIDER      = 'SINGLE_ITEM_RESET_SLIDER';
const POINT_ASSIGNMENT_RESET_SLIDER = 'POINT_ASSIGNMENT_RESET_SLIDER';
const INFINITE_RESET_SLIDER         = 'INFINITE_RESET_SLIDER';
const LOADER                        = 'LOADER';
const RESET_ALL_SURVEY              = 'RESET_ALL_SURVEY';
const LOAD_INSTRUMENT               = 'LOAD_INSTRUMENT';
const PUT_ALL_SUCCESS               = 'PUT_ALL_SUCCESS';
const PUT_ALL_ERROR                 = 'PUT_ALL_ERROR';
const SPINNER                       = 'SPINNER';
const LOST_CONNECTION               = "LOST_CONNECTION";
const GET_ALL_ITEM_RESPONSE         = "GET_ALL_ITEM_RESPONSE";
const GET_ALL_FOR_MULTIPLE_RESPONSE = "GET_ALL_FOR_MULTIPLE_RESPONSE";
const PUT_ALL_RESPONSE              = 'PUT_ALL_RESPONSE';
const GET_ASSESSMENT_INFO           = 'GET_ASSESSMENT_INFO';
const GET_ASSESSMENT_INFO_COL       = 'GET_ASSESSMENT_INFO_COL';
const IS_API_UPDATE                 = 'IS_API_UPDATE';
const PUT_ALL_SUCCESS_STATUS        = 'PUT_ALL_SUCCESS_STATUS';
export {
    REMOVE_ALL_ASSESSMENTS,
    ADD_ASSESSMENT,
    SET_FORM_GUID,
    CLEAR_FORM_GUID,
    GET_ASSESSMENT,
    GET_SESSION_HEADER,
    GET_SURVEY,
    GET_ITEMS,
    GET_CSS,
    GET_ANSWERED_QUESTION,
    SCROLL_TO_QUESTION,
    SINGLE_ITEM_RESET_SLIDER,
    POINT_ASSIGNMENT_RESET_SLIDER,
    INFINITE_RESET_SLIDER,
    LOADER,
    RESET_ALL_SURVEY,
    LOAD_INSTRUMENT,
    PUT_ALL_SUCCESS,
    PUT_ALL_ERROR,
    SPINNER,
    LOST_CONNECTION,
    GET_ALL_ITEM_RESPONSE,
    GET_ALL_FOR_MULTIPLE_RESPONSE,
    PUT_ALL_RESPONSE,
    GET_ASSESSMENT_INFO,
    GET_ASSESSMENT_INFO_COL,
    IS_API_UPDATE,
    PUT_ALL_SUCCESS_STATUS
}
